import { Font } from 'types'
import Styles from './Row.module.scss'
import { DeleteFontButton } from './DeleteFontButton'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface Props {
  font: Font
}

export const Row = ({ font }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <div className={Styles.row}>
      <div
        className={Styles.preview}
        style={{ fontFamily: font.name, fontSize: isSystemRedesignEnabled ? '30px' : '22px' }}
      >
        {font.name}
      </div>
      <DeleteFontButton size={isSystemRedesignEnabled ? 'lg' : 'md'} variant="tertiary" font={font} />
    </div>
  )
}
